module.exports = Syndicate